<template>
  <div class="card-thrid-item card-module-normal">
    <div class="card-item-head">{{ moduleTitle }}</div>
    <div class="card-head-line"></div>
    <div class="card-box" >
      <div v-for="item in list" :key="item[keyname]" class="normal-item">
        <div class="haschild-content">
          <!-- {{ itemTitle(item[titleKey]) }} -->
          <div
            id="dailyCommit"
            style="display: inline-block"
            v-html="item[contentKey]"
          ></div>
        </div>
        <div class="aside">{{ itemDate(item[timeKey]) }}</div>
      </div>
      <empty-box v-if="!list || list.length===0" />
    </div>
  </div>
</template>

<script>
import EmptyBox from '@/components/EmptyBox/index.vue'
export default {
  name: "HomeNormalCard",
  components:{
    EmptyBox
  },
  props: {
    moduleTitle: {
      type: String,
      default: "百川盈孚数据",
    },
    keyname: {
      type: String,
      default: "newsId",
    },
    list: {
      type: Array,
      default: () => [],
    },
    titleKey: {
      type: String,
      default: "newsCategoryName",
    },
    contentKey: {
      type: String,
      default: "newsTitle",
    },
    timeKey: {
      type: String,
      default: "updateTime",
    },
  },
  computed: {
    itemTitle() {
      return (title) => {
        if (title) return `【${title}】`;
        return "";
      };
    },
    itemDate(){
      return (timeStr) => {
        let date = new Date(timeStr);
        const year = date.getFullYear()
        const month = "0" + (date.getMonth() + 1);
        const day = "0" + date.getDate();
        return `${year}-${month.slice(-2)}-${day.slice(-2)}`;
      };
    }
  },
};
</script>

<style>
</style>